export default __webpack_public_path__ + "locales/pl/PDFFormDialog.json?hash=f8078ac0c48997a10b7aa71da5934959";